import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import {
  MobileRobustMethod,
  MobileDesignUserExp,
  MobileEnsuring,
  MobileBusniessScale,
  MobileIdeaValid,
  TestIcon,
} from "../../../app-constants";

import { Link } from "gatsby";

const WorkFlow = [
  {
    logo: MobileIdeaValid,
    title: "Concept Validation",
    description:
      "Analyze user needs and market potential to refine app concepts.",
    count: "01",
  },
  {
    logo: MobileDesignUserExp,
    title: "Interactive Design",
    description:
      "Create engaging, user-centric designs that enhance usability.",
    count: "02",
  },
  {
    logo: MobileRobustMethod,
    title: "Core Development",
    description:
      "Build a resilient, scalable, and high-performing app foundation.",
    count: "03",
  },
  {
    logo: MobileEnsuring,
    title: "Comprehensive Testing",
    description:
      "Conduct extensive testing to ensure flawless app performance.",
    count: "04",
  },
  {
    logo: TestIcon,
    title: "Efficient Rollout",
    description: "Deploy with a focus on reliability and minimal disruptions.",
    count: "05",
  },
  {
    logo: MobileBusniessScale,
    title: "Lifecycle Management",
    description: "Maintain, update, and optimize for sustained app success.",
    count: "06",
  },
];
const Workflow = () => {
  return (
    <div className="workflow p-100 mobile_app_process_speed">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Effort-Minimized, Easy App Development</h2>
            <p>
              Our zero-hassle process eliminates complexity and ensures seamless
              navigation. Our mobile app development company in the USA is
              trusted to deliver intuitive, user-friendly, and
              performance-optimized products from ideation to deployment.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="my-auto">
              <div className="workflow_items">
                <div className="item_name">
                  <span>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center mt-5"
          >
            {/* <Link
              style={{ background: "#f47a1f", color: "#fff" }}
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Talk To Our Experts
            </Link> */}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
